import { Ref } from 'vue';
import { FieldHtmlNameUtil, HekateDisplayForm } from 'www-shared';
import ExternalUtil from '../../../../../ExternalUtil';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';
import UnifiedSignupSessionInfo from '../session-info/UnifiedSignupSessionInfo';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';

export default class EmailCheck401SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-401';

  private readonly onUpdatePage: VoidFunction;

  private isEduRenew: boolean;

  private isProUpgrade: boolean;

  constructor({
    sessionInfo,
    formDefinition,
    isBackButtonHidden,
    onUpdatePage,
  }: {
    sessionInfo: Ref<UnifiedSignupSessionInfo>;
    formDefinition: Ref<HekateDisplayForm>;
    isBackButtonHidden: Ref<boolean>;
    onUpdatePage: VoidFunction,
  }) {
    super({ sessionInfo, formDefinition, isBackButtonHidden });
    this.onUpdatePage = onUpdatePage;
    this.isEduRenew = false;
    this.isProUpgrade = false;
  }

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (emailCheckCode !== 401 || this.sessionInfo.value.isEduRenew || this.sessionInfo.value.isProUpgrade) {
      return false;
    }
    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    if (this.isEduRenew) {
      this.sessionInfo.value.intent = UnifiedSignupIntent.eduIntent;
      this.sessionInfo.value.isEduRenew = true;
    }

    if (this.isProUpgrade) {
      this.sessionInfo.value.isProUpgrade = true;
      this.sessionInfo.value.startScreen = UnifiedSignupStartScreen.trialPlan;
    }
    return true;
  }

  public async initListeners({
    partialDiv,
  }: {
    partialDiv: HTMLDivElement
  }): Promise<void> {
    const intentButton = partialDiv.querySelector('[uss-session-info-intent]');
    if (intentButton) {
      intentButton.addEventListener('click', () => {
        this.isEduRenew = true;
        this.onUpdatePage();
      });
    }

    // if there is a pro trial button, add a listener to it or hide it the user is not eligible.
    const proTrialButton = partialDiv.querySelector('[uss-session-info-start-screen]');
    if (proTrialButton) {
      if (this.sessionInfo.value.isDiscoEligible) {
        proTrialButton.addEventListener('click', () => {
          this.isProUpgrade = true;
          this.onUpdatePage();
        });
      } else {
        proTrialButton.closest('.col-md-3')?.classList.add('d-none');
      }
    }

    if (this.sessionInfo.value.startScreen.compareTo(UnifiedSignupStartScreen.buyStandard)) {
      partialDiv.querySelectorAll('.error-box').forEach((elm) => elm.classList.add('d-none'));
      // hide generic error msg, show redirect specific msg
      const toHide = document.querySelector('[hekate-data=options-msg]');
      const toShow = document.querySelector('[hekate-data=redirect-msg]');
      if (toHide && toShow) {
        toHide.classList.add('d-none');
        toShow.classList.remove('d-none');
      }

      ExternalUtil.redirectTo({ delay: 3000, target: this.getField(FieldHtmlNameUtil.signupRedirectUrl).val as string });
    }
  }
}
